import { useContext } from "react";
import { TooltipContext } from "@contexts/TooltipContext";

export const useTooltip = () => useContext(TooltipContext);
